<elder-basic-pane-layout class="full">
  <elder-pane>
    <elder-table
      class="flex"
      matSort
      [data]="data"
      [idField]="'id'"
      (itemClick)="openDetail($event)"
    >
      <elder-data-toolbar
        *elderTableToolbar
        (requestNew)="create()"
        [canRemove]="false"
        [canAdd]="true"
        [canMore]="false"
      >
        <ng-template elderToolbarContent="center">
          <elder-search-box
            dense
            class="flex-60 pt-xs"
            queryKey="query"
            [autoPanel]="false"
            [elderSearchContext]="data.filter"
          >
          </elder-search-box>
        </ng-template>
      </elder-data-toolbar>

      <!-- icon -->
      <ng-container matColumnDef="icon">
        <th mat-header-cell *matHeaderCellDef style="width: 5%"></th>
        <td mat-cell *matCellDef="let row">
          <mat-icon>label</mat-icon>
        </td>
      </ng-container>

      <!-- label Column -->
      <ng-container matColumnDef="label">
        <th mat-header-cell *matHeaderCellDef style="width: 15%" mat-sort-header>
          {{ 'production_codes.label' | translate }}
        </th>
        <td mat-cell *matCellDef="let prodCode">{{ prodCode.label }}</td>
      </ng-container>

      <!-- code Column -->
      <ng-container matColumnDef="code">
        <th mat-header-cell *matHeaderCellDef style="width: 15%" mat-sort-header>
          {{ 'production_codes.code' | translate }}
        </th>
        <td mat-cell *matCellDef="let prodCode">{{ prodCode.code }}</td>
      </ng-container>

      <!-- description Column -->
      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'production_codes.default_message' | translate }}
        </th>
        <td mat-cell *matCellDef="let prodCode">{{ prodCode.defaultMessage }}</td>
      </ng-container>
    </elder-table>
  </elder-pane>
</elder-basic-pane-layout>
